export default __webpack_public_path__ + "6a0756bd083c9d411d4ca9c9b0b93787.png";